import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { adminLogo } from "../../assets/image";
import { useEffect, useState } from "react";
import { useAppMutation } from "../../api/fetchClient";
import { LOGIN_URL } from "../../api/url";
import { toast } from "react-toastify";
import { setNavigate } from "../Navigation/Navigation";
import { safeJSONParse } from "../../utils/safeJSONParse";

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  const [showPassword, setShowPassword] = useState(false);
  const { mutate: loginUser } = useAppMutation();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rememberMe: false,
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Required"),
      password: Yup.string().min(6, "Password must be at least 6 characters").required("Required"),
    }),

    onSubmit: async (values, { setSubmitting }) => {
      const data = {
        email: values.email,
        password: values.password,
      };

      loginUser(
        {
          url: LOGIN_URL,
          method: "POST",
          data: data,
        },
        {
          onSuccess: (res) => {
            if (values.rememberMe && data?.email && data?.password) {
              localStorage.setItem("loginData", JSON.stringify(data));
            } else {
              localStorage.removeItem("loginData");
            }

            localStorage.setItem("authToken", "true");
            localStorage.setItem("adminData", JSON.stringify(res?.results));
            navigate("/admin");
          },
          onError: (err) => {
            toast.error(err?.message || "An error occurred");
          },
          onSettled: () => setSubmitting(false),
        }
      );
    },
  });

  useEffect(() => {
    const savedData = safeJSONParse(localStorage.getItem("loginData"));
    if (savedData && savedData.email) {
      formik.setFieldValue("email", savedData.email || "");
      formik.setFieldValue("password", savedData.password || "");
      formik.setFieldValue("rememberMe", true);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="w-full max-w-[400px] bg-white rounded-2xl shadow-lg p-8">
    
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center">
            <img src={adminLogo} alt="" className="flex" />
          </div>
        </div>

        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-dark">Welcome Back!</h2>
          <p className="text-sm text-gray-600 mt-1">Please sign in to continue</p>
        </div>

        <form onSubmit={formik.handleSubmit} className="space-y-5">
          <div>
            <div className="relative">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Email address"
                className={`w-full px-4 py-3 bg-gray-50 rounded-lg text-dark text-sm
                  focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white transition-all
                  ${formik.errors.email && formik.touched.email ? "border-red-300" : "border-transparent"}`}
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email && (
                <p className="mt-1 text-xs text-red-500">{formik.errors.email}</p>
              )}
            </div>
          </div>
         
          <div>
            <div className="relative">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className={`w-full px-4 py-3 bg-gray-50 rounded-lg text-dark text-sm
            focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white transition-all
            ${formik.errors.password && formik.touched.password ? "border-red-300" : "border-transparent"}`}
                {...formik.getFieldProps("password")}
              />

            
              <button
                type="button"
                className="absolute right-3 top-[25px] transform -translate-y-1/2 text-sm"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "Hide" : "Show"}
              </button>

              {formik.touched.password && formik.errors.password && (
                <p className="mt-1 text-xs text-red-500">{formik.errors.password}</p>
              )}
            </div>
          </div>

      
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="rememberMe"
                type="checkbox"
                className="h-4 w-4 text-blue-500 rounded border-gray-300 focus:ring-blue-500/20"
                checked={formik.values.rememberMe}
                onChange={formik.handleChange}
              />
              <label htmlFor="remember-me" className="ml-2 text-sm text-gray-600">
                Remember me
              </label>
            </div>
          </div>
  
          {formik.errors.submit && (
            <div className="text-sm text-red-500 bg-red-50 p-3 rounded-lg text-center">{formik.errors.submit}</div>
          )}

          <button
            type="submit"
            className="w-full bg-primary text-white py-3 rounded-lg font-medium
              hover:bg-primary focus:outline-none focus:ring-2 focus:ring-blue-500/20
              transform transition-all duration-150 hover:shadow-lg"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
